import BaseService from "./base.service";
import { ResponseWrapper } from "./response_wrapper";

class RaterAccountsService extends BaseService {
  constructor() {
    super();
  }

  /**
   * GET rater-accounts/status
   * Pool counts plus the health of the reset job that returns accounts to it
   */
  public async getStatus(): Promise<ResponseWrapper> {
    const path = "rater-accounts/status";
    return await this.request(
      {
        method: "get",
        url: path
      },
      { useToken: "access" }
    );
  }

  /**
   * POST rater-accounts/reset
   * Releases in-use accounts back to the pool. Idempotent.
   * @param force when true, releases accounts still within the cooldown window
   */
  public async reset(force = false): Promise<ResponseWrapper> {
    const path = "rater-accounts/reset";
    return await this.request(
      {
        method: "post",
        url: path,
        data: { force }
      },
      { useToken: "access" }
    );
  }
}

export default new RaterAccountsService();
